import type { QueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PROPERTY_DETAIL_COLUMNS } from "@/lib/property-columns";

/**
 * Warm the ["property", slug] cache used by PropertyDetail. Called on
 * pointer/focus of PropertyCard so navigation feels instant. Safe to call
 * repeatedly — react-query dedupes and respects staleTime.
 */
export const prefetchProperty = (queryClient: QueryClient, slug: string) => {
  return queryClient.prefetchQuery({
    queryKey: ["property", slug],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("properties")
        .select(PROPERTY_DETAIL_COLUMNS)
        .eq("slug", slug)
        .eq("is_active", true)
        .maybeSingle();
      if (error) throw error;
      return data ? { ...data, image: data.image_url } : null;
    },
    staleTime: 5 * 60 * 1000,
  });
};
